var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8633 1.36328C15.082 1.80078 15 2.32031 14.6992 2.67578L10.1602 8.22656V11.8359C10.1602 12.4102 9.69531 12.875 9.12109 12.875C8.90234 12.875 8.68359 12.8203 8.49219 12.6836L6.25 10.9609C5.97656 10.7422 5.8125 10.4414 5.8125 10.0859V8.22656L1.27344 2.67578C0.972656 2.32031 0.890625 1.80078 1.10938 1.36328C1.30078 0.925781 1.76562 0.625 2.25781 0.625H13.7148C14.207 0.625 14.6719 0.925781 14.8633 1.36328ZM9.06641 7.51562L13.6055 1.96484H2.36719L6.90625 7.51562C7.04297 7.67969 7.125 7.87109 7.125 8.08984V9.94922L8.875 11.3164V8.0625C8.875 7.84375 8.92969 7.65234 9.06641 7.51562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angle-right.70a4cfd5c8ba5755c24a7abd0f80d1f4.svg";
export { ForwardRef as ReactComponent };